import { strings } from '@/services/translation/strings';
import * as React from 'react';
import { Modal, ModalProps } from './Modal';

export interface ConfirmDialogProps extends ModalProps {
  title?: string;
  onConfirm: () => void;
  confirmLabel?: string;
  cancelLabel?: string;
  dangerous?: boolean;
  loading?: boolean;
  confirmDisabled?: boolean;
}

export const ConfirmDialog: React.FC<ConfirmDialogProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  children,
  confirmLabel,
  cancelLabel,
  dangerous,
  loading,
  confirmDisabled
}) => {
  return (
    <Modal
      open={open}
      onClose={onClose}
      className="space-y-4"
      header={title || strings.common.confirm}
      cancelLabel={cancelLabel || strings.common.no}
      customActions={[
        {
          label: confirmLabel || strings.common.yes,
          callback: onConfirm,
          primary: true,
          dangerous,
          loading,
          disabled: confirmDisabled
        }
      ]}
    >
      {children}
    </Modal>
  );
};
